import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";

class AuthService {
  //Layer
  login(user) {
    return axiosInstance
      .post("login", {
        login: user.username,
        password: user.password
      }, {
        headers: authHeader(true),
      })
      .then((response) => {
        if (response.status) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response;
      });
  }

  getPanelSetting() {
    return axiosInstance.get("panel-setting", {
      headers: authHeader(true)
    });
  }

  getProfile() {
    return axiosInstance.get("user-profile", {
      headers: authHeader()
    });
  }
}

export default new AuthService();
